import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { Suscripcion } from "../models/suscripcion";
import { global } from "../global";
@Injectable({
  providedIn: "root",
})
export class OperacionService {
  apiUrl: string = "";
  licencia: string = "";

  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.apiUrl = global.url + "operaciones";
    this.licencia = this.cookieService.get("auth_token"); // Obtén el token de las cookies
  }

  listarOperacionesActualizadas(
    userId: number,
    fechaActualizacion: string,
    pagina: number,
    limite: number,
    fechaPeriodo?: string,
    idModelo?: number,
    idCartera?: number,
    fechaSeleccionada?: string,modeloSeleccionadoTipo?:string
  ): Observable<any> {
    
    let params = new HttpParams()
      .set("userId", String(userId))
      .set("fechaInicio", fechaActualizacion)
      .set("pagina", String(pagina))
      .set("limite", String(limite))
      .set("fechaPeriodo", fechaPeriodo!!)
      .set("idModelo", idModelo ? String(idModelo) : 0)
      .set("idCartera", idCartera ? String(idCartera) : 0)
      .set("fechaSeleccionada", String(fechaSeleccionada))
      .set("modeloSeleccionadoTipo", String(modeloSeleccionadoTipo));
    
      return this.http.get(`${this.apiUrl}/buscarActualizadas`, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }
}
